//Nav item names 
export const WhoAmiCmd = 'whoami';
export const ExperienceCmd = 'experience';
export const CommunityCmd = 'community';
export const OtherThingsCmd = 'otherthings';

//Experience Sub Nav item names 
export const Synctera = 'synctera';
export const Koho = 'koho';
export const Atb = 'atb';
export const Education = 'education';

//Responsive breakpoints 
export const Small = '900px';
export const Medium = '1300px';